import React from "react";

// The reference joker result modal uses its "front" card set (50x70), not the admin 200x250 one.
const FRONT_CARDS = `${import.meta.env.BASE_URL}img/cards-front`;
const cardImg = (token) => {
  const t = String(token || "").trim();
  return `${FRONT_CARDS}/${!t || t === "0" ? "1" : t}.png`;
};

function PlayerCards({ name, cards }) {
  return (
    <div className="casino-result-content-item text-center">
      <div className="casino-result-cards">
        <div className="d-inline-block">
          <h4>{name}</h4>
          {cards.map((c, i) => (
            <React.Fragment key={i}>
              {" "}
              <div className="casino-result-cards-item">
                <img src={cardImg(c)} alt="" />
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

/**
 * Reference result body for Unlimited Joker Oneday / 20-20 (joker1, joker120):
 * .row.row5 > .col-12.col-lg-7 > .casino-result-content.joker-result >
 *   (divider d-none, Player A = cards[0,2,4], divider, Player B = cards[1,3,5]).
 * No winner trophy and no description column in the reference.
 */
export default function Joker1ResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim());
  const pick = (idx) => idx.map((i) => cards[i]);

  return (
    <div className="row row5">
      {cards.length > 0 && cards[0] !== "" && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content joker-result">
            <div className="casino-result-content-diveder d-none" />{" "}
            <PlayerCards name="Player A" cards={pick([0, 2, 4])} />{" "}
            <div className="casino-result-content-diveder" />{" "}
            <PlayerCards name="Player B" cards={pick([1, 3, 5])} />
          </div>
        </div>
      )}
    </div>
  );
}
